import React from 'react';
import { Select, Option, Autocomplete } from '@mui/joy';

const controlSx = {
  minHeight: 42, minWidth: 0, borderRadius: '11px', fontSize: '14px',
  borderColor: '#e8e3f1', bgcolor: '#fff', color: '#27213d',
  '--Select-focusedHighlight': '#a78bfa', '--Input-focusedHighlight': '#a78bfa',
};
const listboxProps = {
  'data-storage-popup': 'true',
  className: 'st-joy-popup',
  sx: {
    zIndex: 32000, maxHeight: 280, p: '6px', borderRadius: '12px',
    bgcolor: '#fff', border: '1px solid #e8e3f1',
    boxShadow: '0 12px 36px #2d174b24', color: '#27213d',
    '& [role="option"]': { borderRadius: '8px', fontSize: '14px', py: '9px' },
    '& [role="option"][aria-selected="true"]': { bgcolor: '#eee7fc', color: '#6941c6' },
    '& [role="option"]:hover': { bgcolor: '#f4efff' },
  },
};

export function StorageSelect({ options, value, onChange, label, disabled = false, sx }) {
  return <Select className="st-joy" aria-label={label} value={value} disabled={disabled}
    onChange={(_, next) => { if (next !== null) onChange(next); }}
    slotProps={{ listbox: listboxProps }} sx={{ ...controlSx, ...sx }}>
    {options.map(option => <Option key={option.id} value={option.id}>{option.name}</Option>)}
  </Select>;
}

export function StorageAutocomplete({ options, value, onChange, inputValue, onInputChange,
  label, loading = false, disabled = false, serverSearch = true }) {
  return <Autocomplete className="st-joy" aria-label={label} placeholder={label}
    options={options} value={value} inputValue={inputValue} loading={loading} disabled={disabled}
    onChange={(_, next) => onChange(next)}
    onInputChange={(_, text, reason) => onInputChange(text, reason)}
    getOptionLabel={option => option?.name || ''}
    isOptionEqualToValue={(option, selected) => option.id === selected.id}
    renderOption={(props, option) => <li {...props} key={option.id}>{option.name}</li>}
    {...(serverSearch ? { filterOptions: list => list } : {})}
    loadingText="Ищем…" noOptionsText="Ничего не найдено"
    clearText="Очистить" openText="Открыть список" closeText="Закрыть список"
    openOnFocus slotProps={{ listbox: listboxProps }} sx={controlSx} />;
}